// extracted by mini-css-extract-plugin
module.exports = {"trigger":"AddAction_trigger__1LaYS","subMenu":"AddAction_subMenu__aB7-x"};